import React from "react";

function CompanyInfo({ icon, detail, number, className }) {
  return (
    <div className="flex justify-center w-[250px] px-4 py-8 gap-4 items-center rounded-lg bg-slate-500 text-white">
      <div className="bg-blue-700 rounded-full p-1">{icon}</div>
      <div className="flex gap-1 flex-col">
        <h4 className="text-l font-semibold">{detail}</h4>
        <h3 className={`text-2xl font-semibold ${className}`}>{number}</h3>
      </div>
    </div>
  );
}

export default CompanyInfo;
